import { useState } from "react";
import { connect } from "react-redux";
import { AppDispatch } from "store/store";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import { regenerateToken } from "store/slices/TokenSlice";
import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";
import { unwrapResult } from "@reduxjs/toolkit";
import CreateOrUpdateTokenSuccessPopup from "./CreateOrUpdateTokenSuccessPopup";
import { EditorMode } from "shared/enums/EditorModeEnum";

interface Props {
  dispatch?: AppDispatch;
  token?: SubscriptionTokenResponse | null;
  onClose: () => void;
}

export function RegenerateToken(props: Props) {
  const { dispatch, onClose, token } = props;
  const [isTokenRegenerationSuccess, setIsTokenRegenerationSuccess] =
    useState(false);

  const content = "This operation will regenerate the token.";

  const handleConfirm = () => {
    if (token && token.id) {
      dispatch?.(regenerateToken(token.id))
        .then(unwrapResult)
        .then((response: SubscriptionTokenResponse) => {
          setIsTokenRegenerationSuccess(true);
        });
    }
  };

  return (
    <>
      {!isTokenRegenerationSuccess && (
        <ConfirmationDialog
          title="Regenerate token"
          onConfirm={handleConfirm}
          onCancel={onClose}
          content={content}
        />
      )}

      {isTokenRegenerationSuccess && (
        <CreateOrUpdateTokenSuccessPopup
          onClose={onClose}
          mode={EditorMode.Edit}
        />
      )}
    </>
  );
}

export default connect()(RegenerateToken);
